import { render, staticRenderFns } from "./StatusFilter.vue?vue&type=template&id=0a540a80"
import script from "./StatusFilter.vue?vue&type=script&lang=js"
export * from "./StatusFilter.vue?vue&type=script&lang=js"
import style0 from "./StatusFilter.vue?vue&type=style&index=0&id=0a540a80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports